module.exports = __webpack_public_path__ + "img/icon-sztxcl.e3225c15.png";